
import React from "react";
import {
  FaInstagram,
  FaFacebookF,
  FaYoutube,
  FaXTwitter,
  FaEnvelope,
  FaPhone,
  FaLocationDot,
} from "react-icons/fa6";

const Footer = ({ showCta = false }) => {
  return (
    <footer
      className={`relative bg-[#0f172a] text-white ${
        showCta ? "pt-0 pb-16" : "py-16"
      }`}
    >
      <div
        className={`max-w-7xl mx-auto px-6 ${
          showCta ? "pt-16" : ""
        }`}
      >

        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-8 sm:gap-10 lg:gap-6 mb-12">

          {/* Company Logo + Legal Notice */}
          <div className="min-w-0 sm:col-span-2 lg:col-span-2">

            {/* G1 Gold Logo */}
            <div className="flex items-center gap-3 mb-6">
              <img
                src={`${process.env.PUBLIC_URL}/images/logo/g1gold-white-logo.webp`}
                alt="G1 Gold Icon"
                className="h-10 w-auto object-contain"
              />

              <img
                src={`${process.env.PUBLIC_URL}/images/logo/g1gold-white-name.webp`}
                alt="G1 Gold"
                className="h-8 w-auto object-contain"
              />
            </div>

            {/* Legal Notice */}
           
<section
  aria-labelledby="footer-legal-notice"

className="relative lg:-left-3 w-full rounded-xl border border-[#EF4444]/60 bg-[#1D2838] px-5 py-5 shadow-sm"
>


              {/* Heading */}
              <div className="mb-3 flex items-center gap-2">

                <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#EFCB57]/10">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="19"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#EF4444"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M10.3 3.9 2.5 17.5a2 2 0 0 0 1.7 3h15.6a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
                    <path d="M12 9v4" />
                    <path d="M12 17h.01" />
                  </svg>
                </div>

                <h3
                  id="footer-legal-notice"
                  className="text-sm font-bold uppercase tracking-[0.08em] text-[#EF4444] sm:text-base"
                >
                  Disclaimer
                </h3>
              </div>

              {/* Notice Text */}
              

<p className="text-[13px] sm:text-[14px] leading-[1.8] text-gray-300 text-justify [text-align-last:left] hyphens-none break-normal">
  G1 Gold does not accept stolen, fake, or illegally obtained gold,
  and selling such gold may lead to legal action. All customers
  must provide valid ID proof and confirm legal ownership of
  their gold. Customers below 21 years of age must be accompanied
  by a parent or legal guardian, as per G1 Gold company policy
  and applicable laws.
</p>



            </section>
          </div>

          {/* Company */}
          <div className="min-w-0">
            <h4 className="font-semibold text-lg mb-4">
              Company
            </h4>

            <ul className="space-y-3 text-gray-400">
              <li>
                <a
                  href="https://g1gold.com/"
                  className="hover:text-[#EFCB57]"
                >
                  Home
                </a>
              </li>

              <li>
                <a
                  href="https://g1gold.com/about-us"
                  className="hover:text-[#EFCB57]"
                >
                  About Us
                </a>
              </li>

              <li>
                <a
                  href="https://g1gold.com/careers"
                  className="hover:text-[#EFCB57]"
                >
                  Careers
                </a>
              </li>

              <li>
                <a
                  href="https://g1gold.com/branches"
                  className="hover:text-[#EFCB57]"
                >
                  Branches
                </a>
              </li>
            </ul>
          </div>

          {/* Information */}
          <div className="min-w-0">
            <h4 className="font-semibold text-lg mb-4">
              Information
            </h4>

            <ul className="space-y-3 text-gray-400">
              <li>
                <a
                  href="https://g1gold.com/howitworks"
                  className="hover:text-[#EFCB57]"
                >
                  How It Works
                </a>
              </li>

              <li>
                <a
                  href="https://g1gold.com/services"
                  className="hover:text-[#EFCB57]"
                >
                  Services
                </a>
              </li>

              <li>
                <a
                  href="https://g1gold.com/why-g1-gold"
                  className="hover:text-[#EFCB57]"
                >
                  Why G1 Gold
                </a>
              </li>

              <li>
                <a
                  href="https://g1gold.com/gold-calculator"
                  className="hover:text-[#EFCB57]"
                >
                  Contact
                </a>
              </li>

              <li>
                <a
                  href="https://g1gold.com/blogs/"
                  className="hover:text-[#EFCB57]"
                >
                  blogs
                </a>
              </li>
            </ul>
          </div>

          {/* Customer Tools */}
          <div className="min-w-0">
            <h4 className="font-semibold text-lg mb-4">
              Customer Tools
            </h4>

            <ul className="space-y-3 text-gray-400">
              <li>
                <a
                  href="https://g1gold.com/gold-calculator"
                  className="hover:text-[#EFCB57]"
                >
                  Gold Calculator
                </a>
              </li>

              <li>
                <a
                  href="https://g1gold.com/gold-savings-scheme"
                  className="hover:text-[#EFCB57]"
                >
                  Gold Savings Scheme
                </a>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div className="min-w-0">
            <h4 className="font-semibold text-lg mb-4">
              Connect
            </h4>

            <div className="space-y-3 mb-5">

              {/* Phone */}
              <a
                href="tel:+917996800900"
                className="flex items-center gap-3 text-gray-400 hover:text-[#EFCB57] transition-colors"
              >
                <FaPhone className="shrink-0 text-[#FFD51F]" />
                <span>+91 7996 800 900</span>
              </a>

              {/* Primary Email */}
              <a
                href="mailto:info@g1gold.in"
                className="flex items-center gap-3 text-gray-400 hover:text-[#EFCB57] transition-colors break-words"
              >
                <FaEnvelope className="shrink-0 text-[#FFD51F]" />
                <span>info@g1gold.in</span>
              </a>

              {/* Secondary Email */}
              <a
                href="mailto:g1goldcompany@gmail.com"
                className="flex items-center gap-3 text-gray-400 hover:text-[#EFCB57] transition-colors"
              >
                <FaEnvelope className="shrink-0 text-[#FFD51F]" />
                <span className="break-all">
                  g1goldcompany@gmail.com
                </span>
              </a>

              {/* Address */}
              <div className="flex items-start gap-3 text-gray-400">
                <FaLocationDot className="mt-1.5 shrink-0 text-[#FFD51F]" />

                <p className="leading-7 mb-4 text-[15px]">
                  1st Floor, Satya Sai Complex,
                  <br />
                  No. 224, 14th Cross,
                  <br />
                  Sampige Road, Malleswaram,
                  <br />
                  Bengaluru, Karnataka - 560003
                </p>
              </div>
            </div>

            {/* Social Media Icons */}
            <div className="flex items-center gap-4 text-xl text-gray-400">

              <a
                href="https://www.instagram.com/g__one_gold/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#EFCB57]"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>

              <a
                href="https://x.com/G1goldcompany"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#EFCB57]"
                aria-label="X"
              >
                <FaXTwitter />
              </a>

              <a
                href="https://www.facebook.com/profile.php?id=61580697385603"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#EFCB57]"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>

              <a
                href="mailto:g1goldcompany@gmail.com"
                className="hover:text-[#EFCB57]"
                aria-label="Email"
              >
                <FaEnvelope />
              </a>

              <a
                href="https://www.youtube.com/@g-onegoldcompany"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#EFCB57]"
                aria-label="YouTube"
              >
                <FaYoutube />
              </a>

            </div>
          </div>

        </div>

        {/* Bottom Footer */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">

          <p className="text-gray-400 text-sm">
            © 2026 G1 Gold. All rights reserved.
          </p>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400">

            <a
              href="https://g1gold.com/privacy"
              className="hover:text-[#EFCB57]"
            >
              Privacy Policy
            </a>

            <a
              href="https://g1gold.com/terms"
              className="hover:text-[#EFCB57]"
            >
              Terms of Service
            </a>

          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
